import React from 'react';
import { priceFormat } from '../../../../../helpers/calculateDiscountAndCredits';

import './styles.scss';

const BundlePrice = (props) => {
  const {
    isLandingTicket,
    landingTicket,
    oldPrice,
    hideOldPrice,
    finalPrice,
    formattedFinal,
    loyaltyTickets,
    ticketsAmount,
    baseTicketsAmount,
    isDouble,
    is341 = false,
  } = props;
  const isTicketPriceChanged = loyaltyTickets || (oldPrice !== finalPrice) || isDouble;
  const actualTicketsAmount = ticketsAmount + loyaltyTickets;
  return (
    <div className="bundle-price__info bundle-price__info--341">
      <div className="bundle-price__prices">
        <p className="bundle-price__price">
          {isLandingTicket ? priceFormat(landingTicket.totalCost * landingTicket.discountValue) : formattedFinal}
        </p>
        {oldPrice && oldPrice !== finalPrice && !hideOldPrice && (
          <p className="bundle-price__old-price">{priceFormat(Math.round(oldPrice))}</p>
        )}
      </div>
      <div className="bundle-price__tickets">
        {/* {isTicketPriceChanged && !hideOldPrice && (
          <span className="bundle-price__ticket-old-price">{Math.round((oldPrice * 100) / baseTicketsAmount)}p</span>
        )} */}
        <span className="bundle-price__ticket-price">
          {is341 || !isTicketPriceChanged
            ? Math.round((finalPrice * 100) / actualTicketsAmount)
            : Math.floor((finalPrice * 100) / actualTicketsAmount)}
          p / ticket
        </span>
      </div>
    </div>
  );
};

export default BundlePrice;
